// utils/tracking.js
import { trackVisit } from '../services/cmsServices';

// Função para sanitizar strings removendo caracteres especiais e acentos
const sanitizeString = (str) => {
  if (typeof str !== 'string') return str;
  
  return str
    // Remove acentos e caracteres especiais
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    // Remove caracteres especiais como / : . , @ e outros
    .replace(/[\/\:\.\,\@\#\$\%\^\&\*\(\)\+\=\[\]\{\}\|\\\;\'\"\<\>\?\~\`]/g, ' ')
    // Remove espaços extras e quebras de linha
    .replace(/\s+/g, ' ')
    .trim();
};

// Função para sanitizar objetos recursivamente
const sanitizeObject = (obj) => {
  if (obj === null || obj === undefined) return obj;
  
  if (typeof obj === 'string') {
    return sanitizeString(obj);
  }
  
  if (typeof obj === 'number' || typeof obj === 'boolean') {
    return obj;
  }
  
  if (Array.isArray(obj)) {
    return obj.map(item => sanitizeObject(item));
  }
  
  if (typeof obj === 'object') {
    const sanitized = {};
    Object.keys(obj).forEach(key => {
      const sanitizedKey = sanitizeString(key);
      sanitized[sanitizedKey] = sanitizeObject(obj[key]);
    });
    return sanitized;
  }
  
  return obj;
};

// Gerar ID único do visitante
export const getVisitorId = () => {
  let visitorId = localStorage.getItem('visitor_id');
  if (!visitorId) {
    visitorId = 'vis_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('visitor_id', visitorId);
  }
  return visitorId;
};

// Detectar informações do dispositivo
export const getDeviceInfo = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) return 'Tablet';
  if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) return 'Mobile';
  return 'Desktop';
};

export const getBrowserInfo = () => {
  const ua = navigator.userAgent;
  if (ua.indexOf('Chrome') > -1) return 'Chrome';
  if (ua.indexOf('Safari') > -1) return 'Safari';
  if (ua.indexOf('Firefox') > -1) return 'Firefox';
  if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1) return 'IE';
  if (ua.indexOf('Edge') > -1) return 'Edge';
  if (ua.indexOf('Opera') > -1) return 'Opera';
  return 'Unknown';
};

export const getOSInfo = () => {
  const ua = navigator.userAgent;
  if (ua.indexOf('Win') > -1) return 'Windows';
  if (ua.indexOf('Mac') > -1) return 'MacOS';
  if (ua.indexOf('Linux') > -1) return 'Linux';
  if (ua.indexOf('Android') > -1) return 'Android';
  if (ua.indexOf('iOS') > -1) return 'iOS';
  return 'Unknown';
};

// Coletar todas as informações do visitante
export const collectVisitorData = () => {
  const rawData = {
    page: window.location.pathname,
    visitor_id: getVisitorId(),
    timestamp: new Date().toISOString(),
    url: window.location.href,
    referrer: document.referrer,
    user_agent: navigator.userAgent,
    language: navigator.language,
    screen_width: screen.width,
    screen_height: screen.height,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    device: getDeviceInfo(),
    browser: getBrowserInfo(),
    os: getOSInfo(),
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    color_depth: screen.colorDepth,
    pixel_ratio: window.devicePixelRatio || 1
  };
  
  // Sanitiza todos os dados antes de retornar
  return sanitizeObject(rawData);
};

// Função principal de tracking
export const trackPageView = async () => {
  try {
    const trackingData = collectVisitorData();
    
    // Enviar dados de forma assíncrona
    trackVisit(trackingData).catch(error => {
      console.warn('Falha no envio de tracking:', error);
    });
    
  } catch (error) {
    console.error('Erro no tracking:', error);
  }
};

// Função para trackear eventos específicos (cliques, etc)
export const trackEvent = async (eventName, eventData = {}) => {
  try {
    const rawEventData = {
      event: eventName,
      ...collectVisitorData(),
      ...eventData
    };
    
    // Sanitiza todos os dados do evento
    const eventTrackingData = sanitizeObject(rawEventData);
    
    trackVisit(eventTrackingData).catch(error => {
      console.warn('Falha no envio de evento:', error);
    });
    
  } catch (error) {
    console.error('Erro no tracking de evento:', error);
  }
};